export default "<template>\n    <section>\n        <o-pagination :total=\"100\" :per-page=\"10\" disabled />\n    </section>\n</template>\n"